import { Component, ComponentFactoryResolver, Injector, Input, AfterViewInit, OnInit, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { SeaModel } from 'src/app/models/sea/sea-model';
import { StepperService } from '../../stepper.service';
import { Subscription } from 'rxjs';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SeaSearchComponent } from './search/search.component';
import { SeaPriceRequestComponent } from './price-request/price-request.component';
import { SeaReservationInformationComponent } from './reservation-information/reservation-information.component';
import { SeaConfirmationComponent } from './confirmation/confirmation.component';
import { MinDTO } from 'src/app/models/min-dto';
import { ContainerTypeService } from 'src/app/services/container-type/container-type.service';
import { SelectBoxItemModel } from 'src/app/models/select-box-item.model';
import {SearchDetailDialog} from "../../components/search-detail-dialog/search-detail-dialog.component";
import { PStepsComponent } from 'src/app/framework/p-steps/p-steps.component';
import { Router } from '@angular/router';
import { SeaSearchService } from 'src/app/services/sea/sea-search.service';
import { ActivatedRoute } from '@angular/router'; 
import { SeaPriceActionService } from 'src/app/services/sea/sea-price-action.service'; 
import { ChangeDetectorRef } from '@angular/core';
import { SseService } from 'src/app/services/sse-service';
@Component({
  selector: 'app-sea',
  templateUrl: './sea.component.html',
  styleUrls: ['./sea.component.scss']
})

export class SeaComponent extends BaseFormComponentComponent implements OnInit, AfterViewInit, OnDestroy {


  private unsubscriber : Subject<void> = new Subject<void>();

  @Input("step") step: number = 1
  @Input("showOnlyComponent") showOnlyComponent: boolean = false;
  @Input("viewType") viewType: string = null;
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
  @ViewChild("stepper", { static: false }) stepper: PStepsComponent;
  dynamicComponentRef: any;


  model = new SeaModel();
  showRigthPanel: boolean = true;
    panelDisplayOption: any =  {
        showInfo: true,
        showLocation: true,
        showCargo: true,
    }

    containerTypes: MinDTO[] = [];
  freightTypes: SelectBoxItemModel[] = [{code: 'F', name: 'FCL'}, {code: 'P', name: 'LCL'}];

  productLoading: boolean = false;
  searchInfoLoading: boolean = false;
  reservationInfoLoading: boolean = false;
  initialOffsetTop: number = 0;
  parentComponent: SearchDetailDialog;
  isConfirmation = false;
  stepSubscription: Subscription;
  stepComponents = {
    1: SeaSearchComponent,
    2: SeaPriceRequestComponent,
    3: SeaReservationInformationComponent,
    4: SeaConfirmationComponent
  }

  constructor(protected injector: Injector, private seaContainerTypeService: ContainerTypeService, private seaService: SeaSearchService,
     private componentFactoryResolver: ComponentFactoryResolver, private stepperService: StepperService, private router: Router,private activatedRoute: ActivatedRoute,
    public priceActionService: SeaPriceActionService, private cdr: ChangeDetectorRef, private sseService: SseService) {
    super(injector);
    this.model.operationType = "FCL";
  }

  async ngOnInit() {


  this.activatedRoute.queryParams.subscribe(params => {
      if (params.redirect === 'true' && this.priceActionService.pendingReservation) {
          const data = this.priceActionService.pendingReservation;
          this.model = data.model;
          
      
          setTimeout(() => {
              this.stepperService.changeCurrentStep(3);
              
            
              this.renderStepComponent(this.stepComponents[3], this.model, 3);
              
      
              this.cdr.detectChanges();
          }, 200); 
          this.step = 3;
      }
   
      return;
  });

    this.containerTypes = await this.seaContainerTypeService.containers().toPromise();


    if(!this.showOnlyComponent) {
      this.stepperService.changeCurrentStep(this.step);
    }




    history.pushState(null, '');

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      if(this.stepperService.step != 1) {
        if(this.stepperService.step == 3) {
          this.container.clear();
          this.stepperService.changeCurrentStep(1);
        } else {
          this.container.clear();
          this.stepperService.changeCurrentStep(this.stepperService.step -1);
        }
      } else {
        setTimeout(() => { this.router.navigate(['home'], { replaceUrl: true })}, 200);
      }

     

    });


  }



  ngAfterViewInit(): void {


      /* Stepper'dan step numarası değiştirildiğinde... ilgili adıma ait component renderlanıyor.  */
      this.stepSubscription = this.stepperService.currentStep.subscribe((step: number) => {

        if(!this.showOnlyComponent) this.renderStepComponent(this.stepComponents[step]);
      })
  }

  ngOnDestroy(): void {
    this.stepSubscription.unsubscribe();
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  closeDialog(){
      if (this.parentComponent) this.parentComponent.closeDialog();
  }


  renderStepComponent(comp: any, seaModel: SeaModel = this.model, step = 1) {


    if(step == 4 && this.showOnlyComponent) {
      this.panelDisplayOption.showInfo = false;
      this.panelDisplayOption.showLocation = false;
    }


    if( !this.showOnlyComponent && ((this.stepperService.step != 1  && !this.model?.selectedProduct) || this.model.shipmentNo) ) {
        this.showRigthPanel = false;
    }


    this.container.clear();

    switch ( step ) {
        case 1:
            this.searchInfoLoading = true;
            break;
        case 2:
            this.productLoading = true;
            break;
        case 3:
            this.reservationInfoLoading = true;
            break;
        case 4:
            this.reservationInfoLoading = true;
            break;
        default:
            this.isLoading = true;
            break;
    }

    // create the component factory
    const dynamicComponentFactory = this.componentFactoryResolver.resolveComponentFactory(comp);
    // add the component to the view
    const componentRef = this.container.createComponent(dynamicComponentFactory);
    this.dynamicComponentRef = componentRef
    componentRef.instance['model'] = seaModel;
    if( this.viewType) componentRef.instance['viewType'] = this.viewType;

    window.scroll({ top: this.initialOffsetTop,  left: 0, behavior: 'smooth' });

    this.isLoading = false;
    this.productLoading = false;
    this.reservationInfoLoading  = false;
    this.searchInfoLoading = false;

  }
  async reSearch(model:SeaModel) {
    this.isLoading = true;
    this.productLoading = true;

      try {
      
        const segment = await this.seaService.segment(this.model.departurePort.id, this.model.arrivalPort.id, this.model.departureCountry.id, this.model.arrivalCountry.id).toPromise();
        this.model.segment = segment;
        this.model.products = null;
        this.model = await this.seaService.search(this.model).toPromise();
        

        if (this.dynamicComponentRef && this.dynamicComponentRef.instance) {
          
          this.dynamicComponentRef.instance.model = this.model;
          if (this.dynamicComponentRef.instance.cdr) {
              this.dynamicComponentRef.instance.cdr.detectChanges();
          }

          // tekrar fiyat arandığı için ilgili bağlı component'in yeniden init ediyoruz....
          if (this.dynamicComponentRef.instance instanceof SeaPriceRequestComponent) {
              if (typeof this.dynamicComponentRef.instance.ngOnInit === 'function') {
                  this.dynamicComponentRef.instance.ngOnInit();
              }
          }
         
        }

        this.isLoading = false;
        this.productLoading = false;
      } catch {
        this.isLoading = false;
        this.productLoading = false;
      }
      
      
  }
}
